// Đăng ký catalog `host` — chuỗi CỦA RIÊNG admin SaaS (LoginPage wire, InboxPage,
// ApiKeysPage…), tách khỏi catalog cnv-ui. Extract/compile bằng lingui.config.js ở gốc
// admin/ (npm run i18n:extract / i18n:compile).
//
// vi import TĨNH (đi thẳng vào bundle — chuỗi host ít, không đáng tách chunk);
// ngôn ngữ khác dynamic import — viết TƯỜNG MINH từng locale, không template literal
// (template làm Vite glob cả vi → tách vi ra chunk riêng → thêm 1 request vô ích).

import { registerCluster } from '@cnv/ui/i18n';
import { messages } from '../locales/vi/host.mjs';

const loaders = {
  en: () => import('../locales/en/host.mjs'),
  fr: () => import('../locales/fr/host.mjs'),
};

registerCluster('host-admin', messages, (locale) => loaders[locale]());
